import React from 'react';
import { 
  Cloud, 
  Server, 
  Shield, 
  Zap, 
  GitBranch, 
  Monitor, 
  Settings,
  Container,
  Terminal
} from 'lucide-react';
import Reveal from './Reveal';

const Technology: React.FC = () => {
  const technologies = [
    {
      icon: <Cloud className="w-8 h-8" />,
      name: 'AWS',
      description: 'Amazon Web Services',
    },
    {
      icon: <Server className="w-8 h-8" />,
      name: 'Azure',
      description: 'Microsoft Azure',
    },
    {
      icon: <Container className="w-8 h-8" />,
      name: 'OpenShift',
      description: 'Container Platform',
    },
    {
      icon: <Settings className="w-8 h-8" />,
      name: 'Docker',
      description: 'Containerization',
    },
    {
      icon: <Terminal className="w-8 h-8" />,
      name: 'Linux',
      description: 'Operating System',
    },
    {
      icon: <Settings className="w-8 h-8" />,
      name: 'Kubernetes',
      description: 'Container Orchestration',
    },
    {
      icon: <GitBranch className="w-8 h-8" />,
      name: 'Terraform',
      description: 'Infrastructure as Code',
    },
    {
      icon: <Shield className="w-8 h-8" />,
      name: 'DevSecOps',
      description: 'Security Integration',
    },
    {
      icon: <Zap className="w-8 h-8" />,
      name: 'CI/CD',
      description: 'Continuous Integration',
    },
    {
      icon: <Monitor className="w-8 h-8" />,
      name: 'Monitoring',
      description: 'Observability & Logs',
    }
  ];

  return (
    <section id="technology" className="section-padding bg-secondary-900 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-20 w-40 h-40 bg-accent-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-32 h-32 bg-accent-600/5 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        <Reveal className="text-center mb-16">
          <div className="section-badge">
            <Settings className="w-4 h-4 mr-2" />
            Tecnología
          </div>

          <h2 className="section-title">
            Stack
            <span className="text-accent-400 block">Tecnológico</span>
          </h2>

          <p className="section-subtitle max-w-4xl">
            Utilizamos las mejores tecnologías del mercado para construir soluciones
            robustas, escalables y seguras que impulsan el crecimiento de tu negocio.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {technologies.map((tech, index) => (
            <Reveal key={tech.name} delay={(index % 5) * 0.05}>
              <div className="group h-full">
                <div className="surface-card p-6 md:p-8 h-full hover:border-accent-500/40 transition-all duration-300 card-hover text-center">
                  <div className="text-accent-400 mb-4 inline-flex transition-transform duration-300 group-hover:scale-105">
                    {tech.icon}
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2">{tech.name}</h3>
                  <p className="text-gray-500 text-sm">{tech.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technology;
